'use client';

import { createContext, useContext, ReactNode, useMemo } from 'react';
import {
  useWindowDimensions,
  type ThemeBreakpoints,
} from '@template-project/afrodita-components';
import { DeviceType, type DeviceContextValue } from '../types/device';

const DeviceContext = createContext<DeviceContextValue>({
  deviceType: DeviceType.Desktop,
  isMobile: false,
  isTablet: false,
  isDesktop: true,
});

export interface DeviceProviderProps {
  readonly children: ReactNode;
  readonly breakpoints?: Partial<ThemeBreakpoints>;
}

export function DeviceProvider({ children, breakpoints }: DeviceProviderProps) {
  const { isMobile, isTablet, isDesktop } = useWindowDimensions(breakpoints);

  const value = useMemo<DeviceContextValue>(() => {
    let deviceType = DeviceType.Desktop;
    if (isMobile) deviceType = DeviceType.Mobile;
    else if (isTablet) deviceType = DeviceType.Tablet;

    return { deviceType, isMobile, isTablet, isDesktop };
  }, [isMobile, isTablet, isDesktop]);

  return (
    <DeviceContext.Provider value={value}>
      {children}
    </DeviceContext.Provider>
  );
}

export function useDeviceContext(): DeviceContextValue {
  return useContext(DeviceContext);
}
